import React from 'react';
import { useFormContext } from 'react-hook-form';
import { LbInput } from '@infoods/lifebase-ui';

import { ChallengeFormValues } from '../../../../../../interfaces/ChallengeFormValues';
import { STEP_FORM_ID } from '../../GuidedChallengeCreation.settings';
import { validateWhitespace } from '../../../../../../../shared/utils/reactHookFormUtils';

type Props = {
  onNext: () => void;
};

const ChallengeNameStep = ({ onNext }: Props) => {
  const { control, trigger } = useFormContext<ChallengeFormValues>();

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const isValid = await trigger('about.challengeName');

    if (isValid) {
      onNext();
    }
  };

  return (
    <form id={STEP_FORM_ID} onSubmit={onSubmit} noValidate>
      <LbInput
        name="about.challengeName"
        label="Challenge Name"
        control={control}
        rules={{
          required: 'Challenge Name is required',
          validate: { validateWhitespace },
          maxLength: {
            value: 40,
            message: 'Challenge Name must be 40 characters or less',
          },
        }}
        variant="standard"
        size="small"
      />
    </form>
  );
};

export { ChallengeNameStep };
